module.exports = __webpack_public_path__ + "img/SettingsIcon.86da41ac.svg";